import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingPartners = createSelector(
  [selectLandingState],
  ({ partners }) => partners
)
